import Vue from 'vue';
import Router from 'vue-router';

import home from '../views/index.vue';

//import upload_contacts from '../views/import_contacts.vue'
//import users from '../views/Tables/users.vue'

import login from '../views/login.vue'
import password from '../views/password.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  //history: createWebHashHistory(),
  //history: 'createWebHistory',
  beforeEach: (to, from, next) => {
    if (to.name !== 'login' ) {
      if( !localStorage.getItem('active_user_jwt') || !sessionStorage.getItem('active_user_jwt') || ( localStorage.getItem('active_user_jwt') === null && sessionStorage.getItem('active_user_jwt') === null ) ) {
        return next({ name: 'login' })
      }
    }  else { return next({ name: 'login' }) }
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      //redirect: '',
      component: home,
    },
    {
      path: '/login',
      name: 'login',//also figure out :id -> https://router.vuejs.org/guide/essentials/nested-routes.html
      redirect: '',
      component: login
    },
    {
      path: '/password',
      name: 'password',//also figure out :id -> https://router.vuejs.org/guide/essentials/nested-routes.html
      redirect: '',
      component: password
    },
    
    //TODO in future figure this out i need to pass the data back and forth
    //https://medium.com/js-dojo/component-communication-in-vue-js-ca8b591d7efa

  ]
});
